export default __webpack_public_path__ + "static/media/easy.95f50f20.svg";